import { Magic } from 'magic-sdk';

const magic = new Magic('pk_live_8C3E4871438036A9',{ deferPreload: false });

document.getElementById('login-button').addEventListener('click', async () => {
    try {
            console.log('DID Token:');
            const emailInput = document.getElementById('email');
                    const userEmail = emailInput.value;
                    console.log('DID Token:',userEmail);
                    const isLoggedIn = await magic.user.isLoggedIn();
                         console.log('isLoggedIn:',isLoggedIn);
                    if(isLoggedIn){
                         const userMetadata = await magic.user.getInfo();
                              const s=JSON.stringify(userMetadata, null, 2);
                                   console.log('stringify:',s);
                              window.location.href='https://www.glucose.space/magicLogin?token='+s;
                              return;
                              }

   try {
     // Initiate login flow
     const handle = magic.auth.loginWithEmailOTP({ email: userEmail, showUI: true, deviceCheckUI: false });

     handle
     .on(LoginWithEmailOTPEventOnReceived.EmailOTPSent, () => {
       // The email has been sent to the user

       // Prompt the user for the OTP
       const otp = window.prompt('Enter Email OTP');

       // Send the OTP for verification
       handle.emit(LoginWithEmailOTPEventEmit.VerifyEmailOtp, otp);
     })
     .on(LoginWithEmailOTPEventOnReceived.InvalidEmailOtp, () => {
       // User entered invalid OTP

       // Have the user retry entering the OTP and emit via VerifyEmailOtp.
       // You can limit retries and emit Cancel to cancel login flow.

       // cancel login request
       handle.emit(LoginWithEmailOTPEventEmit.Cancel);
     })
     .on('done', (result) => {
         const didToken = result;
            console.log('DID Token:', didToken);
            // 获取用户元数据
           const userMetadata =  magic.user.getInfo();
            console.log('User Metadata:', userMetadata);
       alert('Login complete!'+result);
       console.error(result);


          const s=JSON.stringify(didToken, null, 2);
                 window.location.href='https://www.glucose.space/magicLogin?token='+s;
     })
     .on('error', (reason) => {
       // is called if the Promise rejects
       console.error(reason);
     })
     .on('settled', () => {
       // is called when the Promise either resolves or rejects
     })

     //** MFA Verification Events (if enabled for app)

     .on(LoginWithEmailOTPEventOnReceived.MfaSentHandle, () => {
       // Prompt the user for the MFA TOTP
       const mfa_totp = window.prompt('Enter MFA TOTP');

       // Send the MFA TOTP for verification
       handle.emit(LoginWithEmailOTPEventEmit.VerifyMfaCode, mfa_totp)
     })
     .on(LoginWithEmailOTPEventOnReceived.InvalidMfaOtp, () => {
       // User entered invalid OTP

       // Have the user retry entering the MFA OTP and emit via VerifyMfaCode.
       // You can limit retries and emit Cancel to cancel login flow.

       // cancel login request
       handle.emit(LoginWithEmailOTPEventEmit.Cancel);
     })

     //** Device Verification Events (if enabled for app)

     .on(DeviceVerificationEventOnReceived.DeviceNeedsApproval, () => {
       // is called when device is not recognized and requires approval
     })
     .on(DeviceVerificationEventOnReceived.DeviceVerificationEmailSent, () => {
       // is called when the device verification email is sent
     })
     .on(DeviceVerificationEventOnReceived.DeviceApproved, () => {
       // is called when the device has been approved
     })
     .on(DeviceVerificationEventOnReceived.DeviceVerificationLinkExpired, () => {
       // is called when the device verification link is expired

       // Retry device verification
       handle.emit(DeviceVerificationEventEmit.Retry);
     });

     // LoginWithEmailOTPEventEmit.Cancel can always be emitted to terminate the unresolved request.

   } catch (err) {
     // handle errors
   }

    } catch (err) {
        console.error('Error logging in:', err);
    }
});